<a-combo-box (ngModelChange)="onNgChange($event)" *ngIf="items" [disabled]="disabled" [multiple]="multiple"
             [items]="items" [ngModel]="selection" [required]="required"></a-combo-box>
